import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import { PortfolioUtilities as portfolioUtilities } from '@common/portfolio.utilities';
import { portfolioSelectorService } from '../../portfolioSelector';
import * as echarts from 'echarts';

class PortfolioMauritiusAlternativeInvestmentsController implements angular.IOnInit {

  public alternativeInvestmentsHeight: any;
  public alternativeInvestmentsItems: any;
  public alternativeInvestmentsTotal: any = 0;
  public selectedCurrency: string;


  public alternativeInvestmentsPieChart : any;
  public alternativeInvestmentsPieChartOptions : any;
  public alternativeInvestmentsPieChartData : any;


  /** @ngInject */
  constructor(private portfolioRepo: portfolioRepo, private portfolioUtilities: portfolioUtilities, private portfolioSelectorService : portfolioSelectorService,
              private $timeout: ng.ITimeoutService, $scope: angular.IScope, private notifyjs) {
    var that = this;


    this.portfolioSelectorService.registerCallback('portfolio.mauritius.alternativeInvestments', () => { this.updateData() }); // Need to wrap it in a fat arrow functiom to get the correctly scoped this

  }

  $onInit() {
    this.updateData();
  }

  public formatCurrency(currencyCode: string) {
    if(!this.portfolioSelectorService.isLoading){
      return this.portfolioUtilities.formatCurrency(currencyCode);
    }else{
      return "";
    }
  }

  getAlternativeInvestmentPercentage(alternativeInvestment: any) {
    return (alternativeInvestment.marketValueDisplayCurrency / this.alternativeInvestmentsTotal) * 100;
  }

  public scrollToElement(elementId: string) {
    var that = this;
    this.$timeout(function () { that.portfolioUtilities.scrollToElement(elementId); }, 220);
  }

  public initialisePieChart () {
    // need to put the initialisation of the pie chart in a function because the dom element is not available till
    // the time you have clicked on the pie chart tab.
    var that = this;
    that.alternativeInvestmentsPieChart = echarts.init(document.getElementById('alternative-investments-pie-chart'));
    that.alternativeInvestmentsPieChartOptions = {
      tooltip: {
        trigger: 'item',
        formatter: "{b} : {d}%"
      },
      color: ['#ff0040', '#ff3366','#cc0033'],
      series: {
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '50%'],
        labelLine: {
          normal: {
            show: true
          }
        },
        data: that.alternativeInvestmentsPieChartData
      }

    }
    that.alternativeInvestmentsPieChart.setOption(that.alternativeInvestmentsPieChartOptions);

  }

  updateData() {
    let that = this;
    // alternative investment data
    this.selectedCurrency = this.portfolioSelectorService.getSelectedCurrency()
    this.portfolioSelectorService.setIsLoading(true);
    that.portfolioRepo.getPortfolioAlternativeInvestmentItems(this.selectedCurrency, 'LOCAL', this.portfolioSelectorService.getSelectedPortfolios())
      .then((val) => {
        that.alternativeInvestmentsItems = val.data;

        that.scrollToElement('alternativeInvestments');

        that.alternativeInvestmentsPieChartData = new Array();

        for (var s of that.alternativeInvestmentsItems) {
          that.alternativeInvestmentsTotal += s.marketValueDisplayCurrency;

          that.alternativeInvestmentsPieChartData.push({
            name : s.alternativeInvestmentItem.name,
            value : s.marketValueDisplayCurrency
          });
        }
        this.portfolioSelectorService.setIsLoading(false);

      })
      .catch( (err) => {
        this.portfolioSelectorService.setIsLoading(false);
        this.notifyjs("The Alternative Investments data for the selected portfolios could not be loaded. Please try again later or contact the System Administrator.", "error");
      })
  }
}


export const portfolioMauritiusAlternativeInvestments: angular.IComponentOptions = {
  template: require('../portfolio.mauritius.alternativeinvestments/portfolio.mauritius.alternativeinvestments.html'),
  controller: PortfolioMauritiusAlternativeInvestmentsController
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.mauritius/portfolio.mauritius.alternativeinvestments/portfolio.mauritius.alternativeinvestments.ts